export type SelectedCurrency = 'aud' | 'eur' | 'gbp' | 'usd';

const getChargebeeKey = (site: string) => {
  switch (site) {
    case 'skedsocial-test':
      return 'test_e9B685rVb7cuLJARLvUGRPCqGer3TTdzt';
    case 'skedsocial':
      return 'live_wePakXTxA9Q4heMCcAjdO1XeHA4ysN8d'; // needs to be updated when available!

    default:
      throw new Error(`Unknown site: ${site}`);
  }
};

export const getChargebeeSiteAndKey = (selectedCurrency: SelectedCurrency) => {
  const isStaging =
    window.location.host.includes('localhost') || window.location.host.includes('staging');

  // TODO need to update key of production portal as well
  let site = '';
  if (isStaging) {
    site = 'skedsocial-test';
  } else {
    site = `skedsocial`;
  }

  return { site, key: getChargebeeKey(site) };
};
